import React, { useState } from 'react';
import api from './api';

export default function Connexion({ onConnecte }) {
  const [identifiant, setIdentifiant] = useState('');
  const [motDePasse, setMotDePasse] = useState('');
  const [erreur, setErreur] = useState('');
  const [envoi, setEnvoi] = useState(false);

  const soumettre = async (e) => {
    e.preventDefault();
    setEnvoi(true); setErreur('');
    try {
      const { data } = await api.post('/auth/login', { identifiant, mot_de_passe: motDePasse });
      localStorage.setItem('a97vin-token', data.token);
      onConnecte(data.utilisateur);
    } catch (err) {
      setErreur(err.response?.data?.error || 'Connexion impossible.');
    } finally { setEnvoi(false); }
  };

  return (
    <div className="connexion">
      <form className="carte" onSubmit={soumettre}>
        <h1 className="logotype" aria-label="A97 VIN"><span className="a">A</span><span className="n">97</span><span className="app">VIN</span></h1>
        <label htmlFor="id">Identifiant</label>
        <input id="id" value={identifiant} onChange={(e) => setIdentifiant(e.target.value)} autoComplete="username" autoFocus />
        <label htmlFor="mdp">Mot de passe</label>
        <input id="mdp" type="password" value={motDePasse} onChange={(e) => setMotDePasse(e.target.value)} autoComplete="current-password" />
        {erreur && <div className="erreur">{erreur}</div>}
        <button type="submit" disabled={envoi || !identifiant || !motDePasse}>
          {envoi ? 'Connexion…' : 'Se connecter'}
        </button>
      </form>
    </div>
  );
}
